import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

// Styled-components for the search input
const SearchLayout = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 15px;
  background-color: #f5f5f5;
  border-radius: 8px;
  margin: 16px 0;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  }
`;

const StyledInput = styled.input`
  width: 100%;
  border: none;
  background: transparent;
  font-size: 15px;
  color: #333;
  outline: none;

  &::placeholder {
    color: #999;
  }
`;

export const SearchInput = () => {
  const navigate = useNavigate();

  return (
    <SearchLayout
      onClick={() => {
        navigate("/aisearch");
      }}
    >
      {/* <SearchIcon src={"/resources/search_icon_2.png"} /> */}
      <StyledInput type="text" placeholder="어떤 상품을 찾으세요?" readOnly />
    </SearchLayout>
  );
};
